import React from "react";
import { scoreColor } from "@/lib/chiroApi";

/**
 * Small, deterministic score badge. Used in prospect rows + detail.
 * Renders a single integer 0-100 with semantic color, or a muted "—" when null.
 */
export default function ScorePill({ label, value, testid }) {
    const color = scoreColor(value);
    const display = value == null ? "—" : String(value);
    return (
        <span
            data-testid={testid}
            title={`${label}: ${display}/100`}
            className="font-mono text-[9px] uppercase tracking-[0.18em] px-1.5 py-[2px] border rounded-[2px] inline-flex items-center gap-1 shrink-0"
            style={{ color, borderColor: color + "55" }}
        >
            <span className="text-[#9ca3af] mr-0.5">{label}</span>
            <span style={{ color }}>{display}</span>
        </span>
    );
}
